// extracted by mini-css-extract-plugin
export var editButton = "contenu-libre-module--edit-button--6be2a";
export var separator = "contenu-libre-module--separator--dc4f5";
export var zoneLibre = "contenu-libre-module--zone-libre--47665";
export var zoneLibreTitle = "contenu-libre-module--zone-libre-title--59c8a";